import { connect } from 'react-redux';
import actions from '../actions/ui';

import Divider from '../components/Divider';

export default connect(
  (state, ownProps) => ({
    left: state.ui.probingPane.width
  }),
  (dispatch, ownProps) => ({
    onDrag: (w) => dispatch(actions.ui.probingPane.setWidth(w))
  })
)(Divider);
